module.exports = __webpack_public_path__ + "static/media/Tentang Anak.46e25a6b.png";